import { fetchCategorySubline as fetchCategorySublineService } from '@client/services/api/category-subline';
import { getGender } from '@pegasus/mylounge/client/redux/modules/customer/selectors';
import types from './types';

// TODO: clean up this code when we remove the abtest
export const setCategorySubline = (data) => ({
    type: types.FETCH_CATEGORY_SUBLINE.SUCCESS,
    payload: data,
});

// TODO: clean up this code when we remove the abtest
export const fetchCategorySubline = () => (dispatch, getState) => {
    const gender = getGender(getState());

    dispatch({
        type: types.FETCH_CATEGORY_SUBLINE.REQUEST
    });

    return fetchCategorySublineService(gender)
        .then(data => {
            dispatch(setCategorySubline(data));
        })
        .catch(() => {
            dispatch({
                type: types.FETCH_CATEGORY_SUBLINE.ERROR,
            });
        });
};
